import { Inject } from '@/services/di-provider';
import { Component, Provide, Vue, toNative } from 'vue-facing-decorator';
import template from './app.html?raw';
import Breadcrumb from '@/components/Breadcrumb/breadcrumb';
// Types
import type { UserModel } from '@/models/user';
import UserService from '@/services/user';

@Component({
  template,
  components: {
    Breadcrumb
  }
})
class AppLayout extends Vue {
  @Inject(UserService) userService!: UserService;

  @Provide() isUserInfoLoading = true;

  @Provide() user: UserModel = {} as UserModel;

  created() {
    this.getUserInfo();
  }

  async getUserInfo() {
    try {
      this.user = await this.userService.userInfo();
    } finally {
      this.isUserInfoLoading = false;
    }
  }

}

export default toNative(AppLayout);